'use client';
var classes = {"legend":"m_847eaf","legendItem":"m_17da7e62","legendItemColor":"m_6e236e21","legendItemName":"m_8ff56c0d"};

export { classes as default };
//# sourceMappingURL=ChartLegend.module.css.mjs.map
